module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu5.78d4780f.png";